jQuery( document ).ready(function() {
    let $ = jQuery;
    var slickElement = $('.gallery .slider');

    if( $('section.gallery').length ) {
        slickElement.slick({
            // autoplay: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            // centerPadding: '20vw',
            // centerMode: true,
            infinite: true,
            arrows: true,
            rows: 0,
            speed: 1000,
            adaptiveHeight: false,
            variableWidth: true,
            responsive: [
                // {
                //     breakpoint: 992,
                //     settings: {
                //         centerMode: true,
                //         centerPadding: '40px',
                //         slidesToShow: 1
                //     }
                // },
            ]
        });
    }
});